import React, { useRef } from 'react'
import { useTranslation } from '@/libs/next-lang'
import { useModalWrap } from '@/components'
import './index.less'

const useCampaignsGoBackModal = (props: any) => {
  // onConfirm 是初始化传入的回调函数，
  const currentCbRef = useRef(props?.onConfirm || null)
  const { t } = useTranslation(['components'])

  const handleModal = (cb: (e: any) => void) => {
    // 动态的传入回调函数，如下单页左侧，右侧下拉处理的事情都不同
    currentCbRef.current = cb
    showModal?.()
  }

  const { showModal, hideModal, render } = useModalWrap({
    modalProps: {
      title: <span />,
      width: 525,
      // bodyStyle: { padding: 0 },
      maskClosable: false,
      className: '',
      onOk: async () => {
        // @ts-ignore
        return currentCbRef.current?.()
      },
    },
    children: () => <div>{t('components:t95')}</div>,
  })

  return {
    goBackShowModal: handleModal,
    goBackHideModal: hideModal,
    goBackRenderModal: render,
  }
}

export default useCampaignsGoBackModal
